// extracted by mini-css-extract-plugin
export default {"logo":"GoogleAdsCard_logo__8vsF7"};